const dashboardPageNavigationData = {


}
const userPageNavigationData = [
    {
        icon: "<HomeIcon/>",
        href: "/",
        label: "Home",
        fontSize: "large",
        onClick: {},
        onTouchStart: {},
        style: {}
    },
    {
        icon: "<AccountCircleIcon/>",
        href: "/me",
        label: "Account",
        fontSize: "large",
        onClick: {},
        onTouchStart: {},
        style: {}
    },
    {
        icon: "<DashboardIcon/>",
        href: "/dashboard",
        label: "Dashboard",
        fontSize: "large",
        onClick: {},
        onTouchStart: {},
        style: {}
    },
    {
        icon: "</PowerSettingsNewIcon/>",
        href: "",
        label: "logout",
        fontSize: "large",
        onClick: {},
        onTouchStart: {},
        style: {}
    },


]

const transactionsPageNavigationData = {}

export {
    dashboardPageNavigationData,
    userPageNavigationData,
    transactionsPageNavigationData,
}